export default __webpack_public_path__ + "static/media/thumbnail.d86413d7.webp";